module.exports = __webpack_public_path__ + "static/media/white.e5322a85.svg";